/* eslint-disable */
class ItemBase {
  constructor(scene, mesh) {
    this.scene = scene;
    this.mesh = mesh;
  }

  update() {}

  remove() {}

  finalize() {
    this.mesh.dispose();
  }

  set mesh(mesh) {
    this._mesh = mesh;
  }

  get mesh() {
    return this._mesh;
  }
}
export default ItemBase;
